import React, { PropTypes, Component } from 'react';

export default class ForgotPasswordLink extends Component {
  render() {
    return (
      <a {...this.props} key="forgot-password-link" href="https://id.fastmodelsports.com/reset">
        Forgot your password? Click here to reset it
      </a>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/ForgotPasswordLink.jsx